import React, { useState, useEffect } from "react";
import { Modal } from "rsuite";
import { Button} from "../../../components";
import { DatePicker } from "rsuite"
import { getLastFriday } from "../../../utils/helpers";

function CreateExportModal({ open, onClose, onExport }) {
  const [selectedDate, setSelectedDate] = useState(getLastFriday());

  useEffect(() => {
    if (open) {
      setSelectedDate(getLastFriday());
    }
  }, [open]);

  const handleExport = () => {
    if (onExport) {
      onExport(selectedDate);
    }
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} size="xs">
      <Modal.Header>
        <Modal.Title>Create Export</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label htmlFor="export-date">Posting Date: </label>
        <DatePicker
          data-testid="export-date-picker"
          id="export-date"
          type="date"
          defaultValue={selectedDate}
          onChange={e => setSelectedDate(new Date(e.target.value))}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleExport} text="Export" />
        <Button onClick={onClose} text="Cancel" color="blue" />
      </Modal.Footer>
    </Modal>
  );
}

export default CreateExportModal;
